<template>
    <div id="team-info" class="h-100 ml-md-4 mr-md-4">
        <TeamProjects class="tab" ref="teamProjects"></TeamProjects>
        <TeamMembers class="tab d-none" ref="teamMembers"></TeamMembers>
        <ProjectHistory class="tab d-none" ref="projectFullHistory"></ProjectHistory>
        <div class="glasspane"></div>
    </div>
</template>

<script lang="ts">
import {Component, Vue, Ref} from 'vue-facing-decorator';
import {ProjectDto, ResourceDto, TeamDto} from '@/Teams';
import FadingElement from '../utils/FadingElement';
import {ProjectHistoryMethods} from './ProjectHistory';
import TeamMembers from './TeamMembers.vue';
import TeamProjects from './TeamProjects.vue';
import ProjectHistory from './ProjectHistory.vue';
import {TeamCandidatesList} from '@/Routes';
import {handleXhrError} from '@/utils/Ui';

import $ from 'jquery';

@Component({
  components: {TeamMembers, TeamProjects, ProjectHistory},
})
export default class TeamInfo extends Vue {
    public readonly id = '#team-info';

    @Ref
    private teamProjects: TeamProjects;
    @Ref
    private teamMembers: TeamMembers;

    public team: TeamDto | null = null;
    private readonly glasspane = new FadingElement(`${this.id} .glasspane`);
    private projectHistory: ProjectHistoryMethods;

    public showTeamMembers() {
      if (!this.team) return;
      TeamCandidatesList.invoke({ teamRefid: this.team.refid })
        .done((resources: ResourceDto[]) => this.team.resources = resources)
        .fail((jqXhr) => handleXhrError(jqXhr, 'can\'t load candidates'));
      this.showTab('.team-members');
    }

    public showTeamProjects() {
        this.showTab('.team-projects');
    }

    public mounted() {
        // @ts-ignore
        this.projectHistory = this.$refs.projectFullHistory as ProjectHistoryMethods;
    }

    public showFullHistory(project: ProjectDto) {
        this.projectHistory.updateHistory(project);
        this.showTab('.project-full-history');
    }

    public setTeam(team: TeamDto | null) {
        this.team = team;
        this.teamMembers.setTeam(team);
        this.teamProjects.setTeam(team);
        this.setEnabled(team != null);
    }

    public setEnabled(enabled: boolean) {
        this.glasspane.toggle(enabled);
    }

    private showTab(selector: string) {
        const teamInfo = $(this.$el);
        const tab = teamInfo.find(selector);
        if (tab.hasClass('d-none')) {
            teamInfo.find('.tab').addClass('d-none');
            tab.removeClass('d-none');
        }
    }
}
</script>
